module.exports = __webpack_public_path__ + "img/27-min.a0f6a1f6.jpg";